import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McoInvLineList = ({ mcoInv }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!mcoInv) return;

    rowsReq.partition = mcoInv.partition;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('mcoInvId', mcoInv.id));
  }, [mcoInv?.partition, mcoInv?.id]);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Utlization Lines come from system only
  }

  return (
    <EntityList entity="MCO_INV_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />
  )
}
